import { useAppSelector } from '@verantos-dev/app-state-base';
import {
  type DerivedEventLegacy,
  type SimpleEventLegacy,
  type SubjectVariableLegacy,
} from '@verantos-dev/types-cohorts';

import {
  selectCohortBuilderItemIdsToNamesMap,
  selectInUseCohortBuilderItemsMap,
} from '../selectors/cohortBuilderWorkflowSelectors';
import { getInUseCohortBuilderNamesForId } from '../utils/getInUseCohortBuilderNamesForId';

export const useCohortBuilderItemWithInUseItems = (
  cohortBuilderItems:
    | SimpleEventLegacy[]
    | DerivedEventLegacy[]
    | SubjectVariableLegacy[]
    | undefined
) => {
  const inUseCohortBuilderItemsMap = useAppSelector(selectInUseCohortBuilderItemsMap);
  const cohortBuilderItemIdsToNamesMap = useAppSelector(selectCohortBuilderItemIdsToNamesMap);
  return cohortBuilderItems?.map((cohortBuilderItem) => {
    const inUseItems = getInUseCohortBuilderNamesForId(
      cohortBuilderItem.id,
      inUseCohortBuilderItemsMap,
      cohortBuilderItemIdsToNamesMap
    );
    const isInUse = !!inUseItems && inUseItems.length > 0;
    return {
      ...cohortBuilderItem,
      isInUse,
      inUseItems,
    };
  });
};
